import React, { createContext, useMemo } from 'react';
import { MatchFunction, PathFunction, compile, match } from 'path-to-regexp';
import useRoutes, { IRoutesInfo } from '../hooks/useRoutes';

export type IMatchType = {
  [key: string]: string | number;
};
export type IRoutesContextObject = {
  to: string;
  match: MatchFunction<IMatchType>;
  toPath: PathFunction<IMatchType>;
};
export type IRoutesContextType = {
  [key: string]: IRoutesContextObject;
};
export const RoutesContext = createContext<null | IRoutesContextType>(null);

export function routesFileToContext(routesFile: IRoutesInfo): IRoutesContextType {
  if (!routesFile) return null;
  const retVal: IRoutesContextType = {};

  Object.keys(routesFile).forEach(key => {
    retVal[key] = {
      to: routesFile[key],
      match: match(key),
      toPath: compile(routesFile[key]),
    };
  });

  return retVal;
}

const RoutesWrapper = ({ children }) => {
  const routesFile = useRoutes();

  const routes = useMemo<IRoutesContextType>(() => routesFileToContext(routesFile), [routesFile]);

  return <RoutesContext.Provider value={routes}>{children}</RoutesContext.Provider>;
};

export default RoutesWrapper;
